import { LinearProgress } from '@mui/material';

import styles from './Toast.module.css';
import globalStyles from '@/Global.module.css';
import { useAppSelector } from '@reduxStore';

interface ToastProgressProps {
	toastId: number;
	message?: string;
	total?: number;
}

export default function ToastProgress({ toastId, message, total }: ToastProgressProps) {
	const toastProgress = useAppSelector((state) => state.toastState.progress.find((toast) => toast.id === toastId));

	function calculatePercentageComplete(total: number, progress?: number) {
		if (!progress) {
			return 0;
		} else {
			return Math.ceil((progress / total) * 100);
		}
	}

	return (
		<div className={globalStyles.bold}>
			<span>{message}</span>
			<div className={styles.progress}>
				{total ? (
					<>
						<LinearProgress
							className={styles.progressbar}
							variant='determinate'
							value={calculatePercentageComplete(total, toastProgress?.current)}
						/>
						<span>{`${String(calculatePercentageComplete(total, toastProgress?.current))}%`}</span>
					</>
				) : (
					<LinearProgress className={styles.progressbar} />
				)}
			</div>
		</div>
	);
}
